/** Build the API call for the /oauth/authorize hand-off: same query, plus the JSON response mode. */
export function buildAuthorizeApiUrl(apiUrl: string, search: string): string {
  const params = new URLSearchParams(search);
  params.set('response_mode', 'json');
  return `${apiUrl}/oauth/authorize?${params.toString()}`;
}
